/**
 * @generated SignedSource<<4a480c1639bd8f3fc2e5d053462133bb>>
 * @relayHash 9c89be231b37da0df08845f19df593a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 069c6aae679e53abd2bb402ff9ec19317ffa81efcb825d89e7ec1e7306382377

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiSupportWebsiteOverviewServiceHubPageQuery } from './uiSupportWebsiteOverviewServiceHubPageQuery.graphql';

const node: PreloadableConcreteRequest<uiSupportWebsiteOverviewServiceHubPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "069c6aae679e53abd2bb402ff9ec19317ffa81efcb825d89e7ec1e7306382377",
    "metadata": {},
    "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
